module.exports = __webpack_public_path__ + "static/img/quadrante_mama_esquerda.a705a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quadrante_mama_esquerda.png
// module id = V6pA
// module chunks = 1